import { render, staticRenderFns } from "./foundedId.vue?vue&type=template&id=6350e512"
import script from "./foundedId.vue?vue&type=script&lang=js"
export * from "./foundedId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports